/**
 * Forgiving leading-character normalizer for portal panel `config.path`.
 *
 * Concatenation is `url + path`, and without normalization an editor entering
 * `path = 'foo/bar'` would produce `https://hostfoo/bar`. We prefix a `/` only
 * when the path doesn't already start with a valid separator — `/`, `?`, or
 * `#` — so query-string and fragment-only paths still concatenate cleanly
 * onto a hostless URL (e.g. `https://host` + `?q=1` → `https://host?q=1`).
 *
 * @param {string|undefined|null} path - editor-supplied path/query/fragment
 * @returns {string} the path, possibly with a `/` prefix; empty string for falsy input
 */
export default function normalizePath(path) {
  if (!path) {
    return '';
  }
  return (/^[#/?]/).test(path) ? path : `/${path}`;
}
